function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import { OPEN_MODAL, CLOSE_MODAL } from '../actions/modalActions';
var initialState = {};
export default function modalReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case OPEN_MODAL:
      return Object.assign({}, state, _defineProperty({}, payload.name, {
        isOpen: true,
        modalProps: payload.modalProps
      }));
    case CLOSE_MODAL:
      return Object.assign({}, state, _defineProperty({}, payload.name, {
        isOpen: false
      }));
    default:
      return state;
  }
}